import React from 'react'
import styled from 'react-emotion'
import ReactGA from 'react-ga'

import Button from './Button'
import cloudbedsBtn from '../../assets/cloudbeds-app-button-bg.png'

const windowGlobal = typeof window !== 'undefined' && window


const RegisterButton = (props) => {

  const moveToRegister = () => {
    if (windowGlobal && windowGlobal.location) {
      ReactGA.event({
        category: 'Scheduling',
        action: 'Moved to Self Registration'
      });
    }
  }
  
  return (
    <Button external to="https://app.trywhistle.com/register?source=whistle-marketing" flat onClick={moveToRegister}>Try It For 30 Days</Button>
  );
}

export default RegisterButton



// WEBPACK FOOTER //
// ./src/components/buttons/RegisterButton.js